import type { FunctionComponent } from "react";

import { Container, Step } from "./styles";

export type Props = {
  articleCardIndex: number;
  totalCardLength: number;
};

export const StoryStyleProgressBar: FunctionComponent<Props> = ({
  articleCardIndex,
  totalCardLength,
}) => {
  const steps = Array.from({ length: totalCardLength });
  return (
    <Container>
      {steps.map((_, index) => (
        <Step $state={articleCardIndex >= index} key={index} />
      ))}
    </Container>
  );
};

StoryStyleProgressBar.displayName = "StoryStyleProgressBar";
